import { InternalMedFormIcon } from "../internal/MedFormIcon.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/variants/MedFormAerosolSprayIcon.tsx
const MedFormAerosolSprayIcon = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(InternalMedFormIcon, {
		...props,
		svgFile: "aerosol-spray-icon.svg",
		alt: t("medicationForm.aerosolSpray")
	});
};

//#endregion
export { MedFormAerosolSprayIcon };